import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Icon, colours } from '@mendeley-internal/react-ui';
import styled from 'styled-components';
import { saveToLibrary } from '../../actions/library';
import { trackEvent } from '../../actions/tracking';

const Saved = styled(Button)`
  background: ${colours('grey2')};
  color: ${colours('grey6')};

  ${Icon}:before {
    color: ${colours('grey6')};
  }

  &:hover {
    background: ${colours('grey2')};
    color: ${colours('grey6')};
    cursor: initial;
  }
`;

function AddToLibrary(props) {
  const {
    doc,
    save,
    status = {},
    user,
  } = props;

  const {
    exists,
    pending,
  } = status;

  if (exists) {
    return (
      <Saved
        size="medium"
        iconName="check"
        iconBefore
        disabled
        data-name="saved-reference"
      >
        Reference added
      </Saved>
    );
  }

  return (
    <Button
      size="medium"
      iconName={pending ? 'loading' : 'plus'}
      animation={pending ? 'spin' : null}
      iconBefore
      disabled={pending}
      data-name="save-reference"
      onClick={() => {
        save({ doc });

        props.trackEvent({
          context: 'Document',
          action: 'AddToLibrary',
          value: {
            origin: 'Header',
            documentId: doc.id,
          },
          version: 2,
          profile_uuid: user,
          label: 'Add to library',
          type: 'button',
        });
      }}
    >
      Add to library
    </Button>
  );
}

AddToLibrary.propTypes = {
  doc: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => ({
  status: state.library[props.doc.id],
  user: state.session.user,
});

const mapDispatchToProps = {
  save: saveToLibrary,
  trackEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToLibrary);



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationActions/AddToLibrary.js